// site.js — the site's name, address and X account, in one place. The site
// was "Premier League Scorigami" (premierleaguescorigami.com, @pl_gami) until
// October 2026; that domain now redirects here.

export const SITE_NAME = "Footygami";
export const SITE_HOST = "footygami.com";
export const SITE_URL = `https://${SITE_HOST}`;
export const X_HANDLE = "footygami";
export const X_URL = `https://x.com/${X_HANDLE}`;

// Still how most people search for it ("premier league scorigami"), so page
// titles and descriptions keep the phrase, and the site's search data lists
// the old name (WebSite JSON-LD alternateName in App.js).
export const FORMER_NAME = "Premier League Scorigami";
